<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg width="60" height="61" viewBox="0 0 75 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="37.5" cy="38.3521" r="37.5" fill="#A6192E" />
    <path d="M31.85 22.7256C32.7613 22.7256 33.5 23.4643 33.5 24.3756V53.9756H29.775C28.8637 53.9756 28.125 53.2369 28.125 52.3256V22.7256H31.85Z" fill="white" />
    <path d="M46.225 22.7256C47.1363 22.7256 47.875 23.4643 47.875 24.3756V53.9756H44.15C43.2387 53.9756 42.5 53.2369 42.5 52.3256V22.7256H46.225Z" fill="white" />
  </svg>
</template>
